module.exports = "<div class=\"dynamic-field form-button\" [formGroup]=\"group\">\n  <button type=\"submit\">\n    {{ config.label }}\n  </button>\n</div>\n"